<template>
  <el-select
    size="mini"
    placeholder="Gestor de Cobro"
    v-bind:value="agent"
    filterable
    clearable
    @change="handleChange"
    :disabled="!IsInRoles([roles.CuentasPorCobrar]) && editAgent == true"
  >
    <el-option
      v-for="agent in agentList"
      :key="agent.id"
      :value="agent.value"
      :label="agent.label"
    >
      <el-avatar
        v-if="agent.image"
        style="float: left"
        size="small"
        :src="agent.image"
      ></el-avatar>
      <el-avatar
        v-else
        style="float: left"
        size="small"
        src="/static/images/avatar-2.jpg"
      ></el-avatar>
      <span style="padding-left: 5px; color: #8492a6; font-size: 12px">{{
        agent.label
      }}</span>
    </el-option>
  </el-select>
</template>

<script>
export default {
  model: {
    prop: "agent",
    event: "change"
  },
  props: {
    agent: {
      type: [Number, String],
      required: false,
      default: null
    },
    editAgent: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.getSeller();
  },
  computed: {
    agentList() {
      return this.$store.getters["sellers/getPaymentAgentCode"];
    }
  },
  methods: {
    async getSeller() {
      await this.$store.dispatch("sellers/fetchPaymentAgentCode", null, {
        root: true
      });
    },
    handleChange(val) {
      // this.$emit("update:agent", val);
      this.$emit("change", val);
      const agent = this.getSeller({ id: val });
      this.$emit("selected-agent", agent);
    }
  }
};
</script>
